import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  WorkflowWidgetConfigurationAttributes,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-finx-tags-container',
  template: `
    <div class="w-100 mb-2">
      <drag-scroll>
        @for (filter of filterOptions; track $index) {
          <div
            drag-scroll-item
            class="drag-scroll-item"
            [style.margin-top]="isGlobalStylingEnabled ? null : filterMarginStyle['margin-top']"
            [style.margin-bottom]="isGlobalStylingEnabled ? null : filterMarginStyle['margin-bottom']"
          >
            <finx-tag
              [label]="filter.name"
              [value]="filter.value"
              [config]="attri"
              [isActive]="filter.isActive"
              (filterChange)="onFilterChange($event)"
              [hideCloseIcon]="hideFilterCloseIcon"
            ></finx-tag>
          </div>
        }
      </drag-scroll>
    </div>
  `,
})
export class FinxTagsContainerComponent {
  @Input() public filterOptions: { name: string; value: string; isActive: boolean }[] = [];
  @Input() public filtersEnabled = false;
  @Input() public attri: WorkflowWidgetConfigurationAttributes;
  @Input() public filterMarginStyle: baseCssConfigStyle = {
    'margin-top': '0px',
    'margin-bottom': '0px',
  };
  @Input() public hideFilterCloseIcon = false;

  get isGlobalStylingEnabled(): boolean {
    return this.attri?.['filterPillConfig']?.['globalStyling'] ?? false;
  }

  @Output() public filterChange = new EventEmitter<{ name: string; value: string; isActive: boolean }>();

  public onFilterChange(filter: { name: string; value: string; isActive: boolean }) {
    this.filterChange.emit(filter);
  }
}
